import React from 'react';

export const Pagination = ({ itemsPerPage, data, onPageChange, currentPage }) => {
    const totalPages = Math.ceil(data.length / itemsPerPage);

    const handleClick = (page) => {
        onPageChange(page);
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];

        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(
                <li key={i}>
                    <button onClick={() => handleClick(i)} className={i === currentPage ? 'py-2 px-4 bg-primary text-white m-1 rounded-md' : 'py-2 px-4 bg-light m-1 rounded-md'}>
                        {i}
                    </button>
                </li>
            );
        }

        return pageNumbers;
    };

    return (
        <nav aria-label="Pagination">
            <ul className='flex flex-wrap overflo-x-croll justify-end mt-3'>
                {renderPageNumbers()}
            </ul>
        </nav>
    );
};